import { type SvgProps, SvgWrapper } from '../utils';

export function ChevronLeftIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M14.4697 5.46967C14.7626 5.17678 15.2374 5.17678 15.5303 5.46967C15.8232 5.76256 15.8232 6.23732 15.5303 6.53022L10.0606 11.9999L15.5303 17.4697C15.8232 17.7626 15.8232 18.2373 15.5303 18.5302C15.2374 18.8231 14.7626 18.8231 14.4697 18.5302L8.46973 12.5302C8.17684 12.2373 8.17684 11.7626 8.46973 11.4697L14.4697 5.46967Z" />
    </SvgWrapper>
  );
}
